<template>
    <div class="carousel-grid-item">
        <div class="card">
            <div class="online" v-if="profile.isOnline"><img src="../../../public/images/picto-online.svg" alt="Online" /></div>
            <div class="card-picture showpointer" @click="view(profile)" >
                <img :src="profile.pictureCode" class="card-img-top" :alt="profile.pseudo" draggable="false">
            </div>
            <div class="card-body">
                <h5 class="card-title showpointer" @click="view(profile)">{{ profile.pseudo }}</h5>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "profile-bloc",
        props: {
            profile: {
                type: Object,
                required: true
            }
        },
        methods: {
            view() {
                this.$router.push(`/${this.$i18n.locale}/profiles/${this.profile.slug}`);
            }
        }
    };
</script>
